import * as React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";
import AlertMessage from '../../common/components/alertMessage/alertMessage';
import { TabView, TabPanel } from 'primereact/tabview';
import * as HelperFunctions from '../../common/functions/helperFunctions';
import Translate from '../../common/functions/translate';
import { UserAdminModel } from "../../models/user/";
import UserTabAccountInfo from './userTabAccountInfo';
import UserTabDiseases from './userTabDiseases';
import { DiseaseForGridModel } from '../../models/disease/diseaseForGridModel';
import { MedicineForListModel } from '../../models/medicine/medicineForListModel';
import UserTabMedicines from './userTabMedicines';
import DiseaseListDialog from './diseaseListDialog';

interface IProps {
  saveClick: any,
  cancelClick: any,
  isVisible: boolean,
  currentUser: UserAdminModel
}

interface IState {
  user: UserAdminModel,
  validationMessage: string,
  diseaseValidationMessage: string,
  isVisibleDiseaseListDialog: boolean
}

class UserAddEditDialog extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    if (!props.currentUser.diseases) {
      props.currentUser.diseases = new Array<DiseaseForGridModel>(0);
    }

    if (!props.currentUser.medicines) {
      props.currentUser.medicines = new Array<MedicineForListModel>(0);
    }

    this.state = {
      user: props.currentUser,
      validationMessage: '',
      diseaseValidationMessage: '',
      isVisibleDiseaseListDialog: false
    };
  }

  componentDidMount() {
  }

  handleChange = (key, value) => {
    const user: UserAdminModel = { ...this.state.user };
    user[key] = value;
    this.setState({ user: { ...user } });
  };

  //TODO: Unite handle change into one method
  handleCheckboxChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value
    const name = target.name;

    const user: UserAdminModel = { ...this.state.user };
    user[name] = value;
    this.setState({
      user: { ...user }
    });
  }

  isValidAddEditForm() {
    let message = '';

    if (!this.state.user.name || this.state.user.name.trim() == '') {
      message += "Please enter 'User Name'.<br />";
    }

    if (!this.state.user.email || this.state.user.email.trim() == '') {
      message += Translate('Please enter Email');
    } else {
      if (!HelperFunctions.validateEmail(this.state.user.email)) {
        message += Translate('Please enter valid Email');
      }
    }

    // if (!this.state.currentMedicine.medicineNumber || this.state.currentMedicine.medicineNumber.trim() == '') {
    // 	message += 'Please enter number.<br />';
    // }

    // if (!this.state.currentMedicine.shortDescription || this.state.currentMedicine.shortDescription.trim() == '') {
    // 	message += 'Please enter short description.<br />';
    // }

    // if (!this.state.currentMedicine.medicineDescription || this.state.currentMedicine.medicineDescription.trim() == '') {
    // 	message += 'Please enter description.<br />';
    // }

    this.setState({
      validationMessage: message
    });

    return message == '';
  }

  handleSaveButton = (event, close) => {
    event.preventDefault();
    if (!this.isValidAddEditForm()) return;

    const user = this.state.user;
    this.props.saveClick(user, close);
  }

  handleCancelButton = () => {
    this.props.cancelClick();
  }

  handleUserDiseaseAddClick = () => {
    this.setState({
      isVisibleDiseaseListDialog: true
    })
  }

  handleUserDiseaseRemoveClick(diseaseId: number) {
    const user = this.state.user;
    const diseaseIndex = user.diseases.findIndex(a => a.diseaseId === diseaseId);
    user.diseases.splice(diseaseIndex, 1);

    this.setState({
      user: user
    })
  }

  handleDiseaseDialogAddButton = (currentDisease: DiseaseForGridModel) => {
    let user = this.state.user;
    if (user.diseases.find(a => a.diseaseId === currentDisease.diseaseId)) {

      let mssg = "Disease " +
        [currentDisease.diseaseCode, currentDisease.diseaseNameBG, currentDisease.diseaseNameEN].filter(Boolean).join(' / ') +
        " already exists!";

      this.setState({
        diseaseValidationMessage: mssg
      });
    } else {
      user.diseases.push(currentDisease);

      this.setState({
        user: user,
        isVisibleDiseaseListDialog: false,
        diseaseValidationMessage: ''
      });
    }
  }

  handleDiseaseDialogCancelButton = () => {
    this.setState({
      isVisibleDiseaseListDialog: false,
      diseaseValidationMessage: ''
    });
  };

  handleUserMedicineAddClick() {

  }

  handleUserMedicineRemoveClick(medicineId: number) {
    const user = this.state.user;
    const medicineIndex = user.medicines.findIndex(a => a.medicineId === medicineId);
    user.medicines.splice(medicineIndex, 1);

    this.setState({
      user: user
    })
  }

  public render() {

    const { user } = this.state;

    let header = 'User ' +
      (user.name ? ' -' : '') +
      (user.name ? ' ' + user.name : '') +
      (user.email ? ' / ' + user.email : '');

    return (
      <>
        <Dialog header={header} responsive={true} width="80%"
          modal={true}
          visible={this.props.isVisible}
          onHide={this.handleCancelButton}
          footer={
            <div>
              <Button label="Save" icon="pi pi-save" onClick={(e) => this.handleSaveButton(e, false)} className="p-button-raised" />
              <Button label="Save & Close" icon="pi pi-check" onClick={(e) => this.handleSaveButton(e, true)} className="p-button-success p-button-raised" />
              <Button label="Cancel" icon="pi pi-times" onClick={this.handleCancelButton} className="p-button-secondary p-button-raised" />
            </div>}
        >
          <div style={{ minHeight: '600px', maxHeight: '650px', overflowY: 'auto' }}>
            {this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
            <TabView >
              <TabPanel header="Account info">
                <UserTabAccountInfo
                  user={user}
                  handleChange={this.handleChange}
                  handleCheckboxChange={this.handleCheckboxChange}
                />
              </TabPanel>
              {/* <TabPanel header="Diseases">
                <UserTabDiseases
                  diseases={user.diseases}
                  handleUserDiseaseAddClick={this.handleUserDiseaseAddClick}
                  handleUserDiseaseRemoveClick={(diseaseId) => this.handleUserDiseaseRemoveClick(diseaseId)}
                />
              </TabPanel>
              <TabPanel header="Medicines">
                <UserTabMedicines
                  medicines={user.medicines}
                  handleUserMedicineAddClick={this.handleUserMedicineAddClick}
                  handleUserMedicineRemoveClick={(medicineId) => this.handleUserMedicineRemoveClick(medicineId)}
                />
              </TabPanel> */}
            </TabView>
          </div>
        </Dialog >

        {this.state.isVisibleDiseaseListDialog ? (
          <DiseaseListDialog
            addClick={this.handleDiseaseDialogAddButton}
            cancelClick={this.handleDiseaseDialogCancelButton}
            isVisible={this.state.isVisibleDiseaseListDialog}
            validationMessage={this.state.diseaseValidationMessage}
          />
        ) : null}
      </>
    )
  }
}

export default UserAddEditDialog;